/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { User, ChevronDown } from 'lucide-react';
import { baseUrlImg } from '../../../Api';
import { Modal } from '@mui/material';
import * as S from './style';
import CustomDropdown from '../../CustomDropDown';
import { MegaMenuPanel } from '../MegaMenu';

export const MenuMobile = ({
  menu,
  setMenu,
  optionsMenu,
  data,
  logoCopasul,
}) => {
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setOpenMobileMenu(false);
    const updateMenu = [...menu];
    updateMenu.forEach((item) => {
      item.status = false;
    });
    setMenu(updateMenu);
  }, [location.pathname]);

  useEffect(() => {
    if (openMobileMenu) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [openMobileMenu]);

  const handleMenuToggle = (index, item) => {
    if (item?.menu?.subMenu?.length > 0) {
      const updateMenu = [...menu];
      updateMenu.forEach((m, i) => {
        m.status = i === index ? !m.status : false;
      });
      setMenu(updateMenu);
    } else if (item?.menu?.rota) {
      const route = item.menu.rota;
      if (route.indexOf('http') !== -1) {
        window.open(route, '_blank');
      } else {
        navigate(route);
      }
      setOpenMobileMenu(false);
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <S.HeaderBox>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 100000,
        }}
      >
        <S.SearchModalBox>
          <S.SearchModalHeader>
            <span>Buscar no site</span>
            <button onClick={handleCloseModal} aria-label="Fechar busca">
              <CloseIcon />
            </button>
          </S.SearchModalHeader>
          <CustomDropdown
            optionsMenu={optionsMenu}
            onSelect={(route) => {
              handleCloseModal();
              setOpenMobileMenu(false);
              if (route.startsWith('http')) {
                window.open(route, '_blank');
              } else {
                navigate(route);
              }
            }}
          />
        </S.SearchModalBox>
      </Modal>

      {/* Barra de cabeçalho padrão no topo da página */}
      <S.FirstBox>
        <S.LogoButton onClick={() => navigate('/')}>
          {logoCopasul && (
            <S.LogoImg
              src={`${baseUrlImg}${logoCopasul}`}
              alt="Logo copasul"
            />
          )}
        </S.LogoButton>

        <S.ButtonsBox>
          <S.IconActionButton onClick={handleOpenModal} aria-label="Buscar">
            <SearchIcon />
          </S.IconActionButton>
          <S.IconActionButton
            onClick={() => setOpenMobileMenu(true)}
            aria-label="Abrir menu"
          >
            <MenuIcon />
          </S.IconActionButton>
        </S.ButtonsBox>
      </S.FirstBox>

      {/* Menu Mobile em Tela Cheia */}
      {openMobileMenu && (
        <S.FullScreenNav>
          <S.FullScreenHeader>
            <S.LogoButton
              onClick={() => {
                setOpenMobileMenu(false);
                navigate('/');
              }}
            >
              {logoCopasul && (
                <S.LogoImg
                  src={`${baseUrlImg}${logoCopasul}`}
                  alt="Logo copasul"
                />
              )}
            </S.LogoButton>

            <S.ButtonsBox>
              <S.IconActionButton onClick={handleOpenModal} aria-label="Buscar">
                <SearchIcon />
              </S.IconActionButton>
              <S.IconActionButton
                onClick={() => setOpenMobileMenu(false)}
                aria-label="Fechar menu"
                $active
              >
                <CloseIcon />
              </S.IconActionButton>
            </S.ButtonsBox>
          </S.FullScreenHeader>

          <S.FullScreenContent>
            <S.MenuNavList>
              {menu.length > 0 && (
                <S.HomeLink to="/" end onClick={() => setOpenMobileMenu(false)}>
                  Início
                </S.HomeLink>
              )}

              {menu.map((item, index) => {
                const hasSubMenu = item?.menu?.subMenu?.length > 0;
                const isOpen = item.status;

                return (
                  <S.MenuItemWrapper key={index}>
                    <S.MenuButton
                      type="button"
                      $isOpen={isOpen}
                      onClick={() => handleMenuToggle(index, item)}
                    >
                      <span>{item?.menu?.tituloMenu}</span>
                      {hasSubMenu && (
                        <ChevronDown
                          className={`chevron-icon ${isOpen ? 'open' : ''}`}
                          size={18}
                        />
                      )}
                    </S.MenuButton>

                    {hasSubMenu && isOpen && (
                      <S.DropdownWrapper>
                        <MegaMenuPanel items={item.menu.subMenu} columns={1} />
                      </S.DropdownWrapper>
                    )}
                  </S.MenuItemWrapper>
                );
              })}
            </S.MenuNavList>

            <S.ActionButtonsSection>
              {data?.botoes?.[0]?.linkBotao?.tituloLink && (
                <S.PortalButton
                  onClick={() => {
                    setOpenMobileMenu(false);
                    if (data?.botoes[0]?.linkBotao?.linkExterno) {
                      window.open(
                        data.botoes[0].linkBotao.linkExterno,
                        '_blank'
                      );
                    }
                  }}
                >
                  <User size={18} />
                  <span>{data?.botoes[0]?.linkBotao?.tituloLink}</span>
                </S.PortalButton>
              )}
            </S.ActionButtonsSection>
          </S.FullScreenContent>
        </S.FullScreenNav>
      )}

    </S.HeaderBox>
  );
};
